// extracted by mini-css-extract-plugin
module.exports = {"weather":"Weather_weather__1u-Zz"};